module.exports = __webpack_public_path__ + "static/img/business-management.47b1c0f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innovation/business-management.jpeg
// module id = IElI
// module chunks = 2